// @ts-check

import {
  DELETE_BUYER,
  GET_BUYER,
  GET_BUYERS,
  RESET_BUYER_CALL_COUNTER,
  GET_BUYER_REFERENCES,
  CREATE_BUYER,
  UPDATE_BUYER,
  HANDLE_LINK_RPC,
  TOGGLE_BUYER_PERMISSION
} from './actionTypes';
import { STATUS_PENDING, getActionStatusName } from '@/store/helpers';

export const changeLogFeatureFlag = state => {
  return state.currentAccountFeatureFlags.changelog;
};

export const isFetchingBuyers = (_, getters) => {
  return (
    getters.getBuyersStatus.status === STATUS_PENDING ||
    getters.getBuyerStatus.status === STATUS_PENDING
  );
};

export const isBuyerReferencesLoading = (_, getters) => {
  return getters.getBuyerReferencesStatus.status === STATUS_PENDING;
};
export const isBuyerResetCapCountersLoading = (_, getters) => {
  return getters.resetBuyerCallCountersStatus.status === STATUS_PENDING;
};

export const isBuyerDeleteLoading = (_, getters) => {
  return getters.deleteBuyerStatus.status === STATUS_PENDING;
};

export const getBuyersStatus = state =>
  state.status[getActionStatusName(GET_BUYERS)] || {};

export const getBuyerStatus = state =>
  state.status[getActionStatusName(GET_BUYER)] || {};

export const deleteBuyerStatus = state =>
  state.status[getActionStatusName(DELETE_BUYER)] || {};

export const resetBuyerCallCountersStatus = state =>
  state.status[getActionStatusName(RESET_BUYER_CALL_COUNTER)] || {};

export const getBuyerReferencesStatus = state =>
  state.status[getActionStatusName(GET_BUYER_REFERENCES)] || {};

export const createBuyerStatus = state =>
  state.status[getActionStatusName(CREATE_BUYER)] || {};

export const updateBuyerStatus = state =>
  state.status[getActionStatusName(UPDATE_BUYER)] || {};

export const handleLinkRpcStatus = state =>
  state.status[getActionStatusName(HANDLE_LINK_RPC)] || {};

export const toggleBuyerPermissionStatus = state =>
  state.status[getActionStatusName(TOGGLE_BUYER_PERMISSION)] || {};

export const getDisplayBuyers = (state, getters) => {
  if (getters.isFetchingBuyers) {
    return [];
  }
  return state.buyers;
};
